import React, { useState, useEffect } from 'react';
import DashboardHeader from '../../../components/DashboardHeader';
import DashboardFooter from '../../../components/DashboardFooter';
import { 
  FaHospital,
  FaFlask,
  FaMoneyBill,
  FaBalanceScale,
  FaBuilding
} from 'react-icons/fa';
import './research.css';
import { auth, db } from '../../../auth/firebase';
import { doc, updateDoc } from 'firebase/firestore';
import cacheManager from '../../../auth/cache_manager';

function Research() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  // # Load theme preference from user data on initial render
  useEffect(() => {
    const loadThemePreference = async () => {
      if (auth.currentUser?.uid) {
        // # Try to get from cache first
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData && userData.themes && userData.themes.gen_theme !== undefined) {
          setIsDarkMode(userData.themes.gen_theme === 'dark');
        }
      }
    };
    
    loadThemePreference();
  }, []);

  // # Handle theme toggle
  const handleThemeToggle = async () => {
    try {
      const newTheme = !isDarkMode;
      setIsDarkMode(newTheme);
      
      // # Update theme in Firebase if user is logged in
      if (auth.currentUser?.uid) {
        // # Update the user document
        await updateDoc(doc(db, 'users', auth.currentUser.uid), {
          'themes.gen_theme': newTheme ? 'dark' : 'light'
        });
        
        // # Update cache manager
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData) {
          const updatedUserData = {
            ...userData,
            themes: {
              ...(userData.themes || {}),
              gen_theme: newTheme ? 'dark' : 'light'
            }
          };
          cacheManager.set(`user_${auth.currentUser.uid}`, updatedUserData);
        }
      }
    } catch (error) {
      console.error('Error updating theme preference:', error);
    }
  };

  // # Define research sections with icons and descriptions
  const researchSections = [
    {
      title: 'Clinical Research',
      icon: <FaHospital className="ext_rsch_section-icon" />,
      description: 'Learn about patient-oriented research and clinical trials'
    },
    {
      title: 'Basic Science Research',
      icon: <FaFlask className="ext_rsch_section-icon" />,
      description: 'Explore laboratory-based biomedical research fundamentals'
    },
    {
      title: 'Funding',
      icon: <FaMoneyBill className="ext_rsch_section-icon" />,
      description: 'Discover funding sources for your research projects'
    },
    {
      title: 'Research Ethics',
      icon: <FaBalanceScale className="ext_rsch_section-icon" />,
      description: 'Learn about the ethical considerations in research'
    },
    {
      title: 'Top Institutes',
      icon: <FaBuilding className="ext_rsch_section-icon" />,
      description: 'Explore the top research institutes in the world'
    }
  ];

  return (
    <div className={`ext_rsch_page-container ${isDarkMode ? 'ext_rsch_dark-mode' : ''}`}>
      <DashboardHeader isDarkMode={isDarkMode} onThemeToggle={handleThemeToggle} />
      
      <main className="ext_rsch_main-content">
        <div className="ext_rsch_header">
          <h1>Research Library</h1>
          <p>Resources for clinical and basic science research methodology</p>
        </div>

        <div className="ext_rsch_sections-grid">
          {researchSections.map((section, index) => (
            <div 
              key={index}
              className="ext_rsch_section-card"
            >
              <div className="ext_rsch_icon-container">
                {section.icon}
              </div>
              <h3>{section.title}</h3>
              <p>{section.description}</p>
              <div className="ext_rsch_coming-soon">Coming Soon</div>
            </div>
          ))}
        </div>
      </main>

      <DashboardFooter isDarkMode={isDarkMode} />
    </div>
  );
}

export default Research; 